import { select } from 'd3-selection';
import { mountZoom, unmountZoom } from './zoom';
import filters, { clearFiltes } from './filters';

const app = document.querySelector('.mapa');
let selected = select(null);

export let currentElementZoomed = null; // eslint-disable-line

function mutableCurrentElementZoomed(el) {
  currentElementZoomed = el;
}

function callCloseZoomMap({ target }) {
  selected.classed('active', false);
  const key = target.getAttribute('key');
  const isZoom = app.getAttribute('isZoomed');
  if (!key && Boolean(isZoom)) {
    unmountZoom();
    clearFiltes();
    app.removeAttribute('isZoomed', '');
  }
}

function restoreMap() {
  const closeZoom = document.querySelector('.controle button');
  closeZoom.onclick = callCloseZoomMap;
}

export function callZoomMap(el) {
  selected.classed('active', false);
  selected = select(this).classed('active', true);
  app.setAttribute('isZoomed', true);
  mutableCurrentElementZoomed(el);
  mountZoom(el);
}

export default () => {
  filters();
  restoreMap();
};



// WEBPACK FOOTER //
// ./src/components/mapa/events.js